import React from "react";

class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      segundos: 120
    };
    this.timer = null;
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState(prevState => ({
        segundos: prevState.segundos - 1
      }));
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  parar = () => {
    clearInterval(this.timer);
    return "Vuelva a solicitar su código";
  };

  render() {
    return (
      <div style={{ color: "red" }}>
        {this.state.segundos < 0
          ? this.parar()
          : `Expira en ${this.state.segundos} segundos.`}
      </div>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/components/timer/time.jsx